<template>
  <div>
    <div
      class="page-header clear-filter d-flex justify-content-center align-items-center"
      filter-color="dark"
    >
      <parallax class="page-header-image" style="background-color:#26a23e"></parallax>
      <div class="content-center">
        <div class="container">
          <div class="content-center brand">
            <h1 class="h1-seo">Servicios del Departamento de Infraestructura</h1>
          </div>
        </div>
      </div>
      <vue-particles color="#bbbbbb" :particleOpacity="0.5" :lineOpacity="0.3" :clickEffect="false"></vue-particles>
    </div>
    <div id="infrastructure-department" class="section section-services">
      <div class="section-story-overview">
        <div class="row">
          <div class="col-md-8 ml-auto mr-auto text-center">
            <h3>Marcas que representamos:</h3>
          </div>
          <div class="col-12">
            <ul class="grid pt-0">
              <grid-item styles="sm rounded no-border" no-margin @click.native="goto('https://www.crestron.com/')">
                <template>
                  <img src="img/brands/crestron.png" alt="Crestron" />
                </template>
              </grid-item>
              <grid-item styles="sm rounded no-border" no-margin @click.native="goto('https://store.google.com/us/category/connected_home')">
                <template>
                  <img src="img/brands/nest.png" alt="Google Nest" />
                </template>
              </grid-item>
              <grid-item styles="sm rounded no-border" no-margin @click.native="goto('https://www.leviton.com/')">
                <template>
                  <img src="img/brands/leviton.png" alt="Leviton" />
                </template>
              </grid-item>
              <grid-item styles="sm rounded no-border" no-margin @click.native="goto('https://www.honeywell.com/')">
                <template>
                  <img src="img/brands/honeywell.png" alt="Honeywell" />
                </template>
              </grid-item>
              <grid-item styles="sm rounded no-border" no-margin @click.native="goto('https://www.ui.com/')">
                <template>
                  <img src="img/brands/ubiquiti.png" alt="Ubiquiti" />
                </template>
              </grid-item>
              <grid-item styles="sm rounded no-border" no-margin @click.native="goto('https://www.vmware.com/latam.html')">
                <template>
                  <img src="img/brands/vmware.png" alt="VMWare" />
                </template>
              </grid-item>
              <grid-item styles="sm rounded no-border" no-margin @click.native="goto('https://www.delltechnologies.com/en-us/index.htm')">
                <template>
                  <img src="img/brands/dell.png" alt="Dell EMC" />
                </template>
              </grid-item>
            </ul>
          </div>
        </div>
      </div>
      <div class="container">
        <!-- <div class="row">
          <div class="col-12 text-center">
            <h2 class="title">Servicios del Departamento de Infraestructura</h2>
          </div>
        </div> -->
        <two-columns position-text="left" centered>
          <template slot="title">
            <h3>Cableado estructurado y fibra óptica</h3>
          </template>
          <template>
            <p
              class="description text-justify"
            >Diseño, ingeniería, instalación y mantenimiento de de Cableado Estructurado y Fibra Óptica, sistemas de Canalización.</p>
            <p
              class="description text-justify"
            >Complementamos el cableado junto con el diseño, ingeniería e instalación de contactos eléctricos polarizados o regulados para redes de voz, datos y video vigilancia.</p>
            <p
              class="description text-justify"
            >Contamos con personal certificado y altamente calificado en el manejo de todos nuestros productos, como empresa comprometida, proveemos equipo adecuado a las necesidades de nuestros clientes asegurando el tránsito de información que pasa a través de la infraestructura de datos.</p>
          </template>
          <template slot="right-text">
            <img src="svg/wired.svg" class="img-fluid py-3" alt="access-control" />
          </template>
        </two-columns>

        <two-columns centered>
          <template slot="title">
            <h3>Control de Accesos</h3>
          </template>
          <template>
            <div
              class="info info-horizontal mw-100 py-2 d-flex justify-content-start align-items-center"
            >
              <div class="icon text-primary m-0">
                <i class="far fa-keyboard"></i>
              </div>
              <div class="description text-left">
                <h5 class="info-title m-0">Teclado</h5>
                <p class="m-0">Realiza la identificación con códigos PIN.</p>
              </div>
            </div>
            <div
              class="info info-horizontal mw-100 py-2 d-flex justify-content-start align-items-center"
            >
              <div class="icon text-primary m-0 mx-1">
                <i class="fas fa-rss"></i>
              </div>
              <div class="description text-left">
                <h5 class="info-title m-0">Proximidad</h5>
                <p
                  class="m-0"
                >Cómodo y seguro: el acceso se controla mediante una tarjeta de proximidad.</p>
              </div>
            </div>
            <div
              class="info info-horizontal mw-100 py-2 d-flex justify-content-start align-items-center"
            >
              <div class="icon text-primary m-0 mr-1">
                <i class="fas fa-fingerprint"></i>
              </div>
              <div class="description text-left">
                <h5 class="info-title m-0">Huella</h5>
                <p
                  class="m-0"
                >Alta seguridad. Reconoce al usuario por su huella, única e irrepetible.</p>
              </div>
            </div>
            <div
              class="info info-horizontal mw-100 py-2 d-flex justify-content-start align-items-center"
            >
              <div class="icon text-primary m-0">
                <i class="far fa-id-card"></i>
              </div>
              <div class="description text-left">
                <h5 class="info-title m-0">Centralizado MDS</h5>
                <p
                  class="m-0"
                >Para grandes instalaciones con diferentes accesos y necesidades avanzadas.</p>
              </div>
            </div>
          </template>
          <template slot="right-text">
            <img src="svg/unlock.svg" class="img-fluid py-3" alt="access-control" />
          </template>
        </two-columns>

        <two-columns position-text="left" centered>
          <template slot="title">
            <h3>Sistemas CCTV</h3>
          </template>
          <template>
            <p
              class="description text-justify"
            >Con la convergencia de la redes de CCTV hacia las redes de datos, este servicio provee la plataforma para él monitoreo físico de las instalaciones mediante el uso de cámaras, grabadoras de video y/o sistemas de almacenamiento integrados a la red de datos.</p>
          </template>
          <template slot="right-text">
            <img src="svg/cctv.svg" class="img-fluid py-3" alt="access-control" />
          </template>
        </two-columns>

        <two-columns centered>
          <template slot="title">
            <h3>Sistemas de Prevención y Supresión de Incendios</h3>
          </template>
          <template>
            <p
              class="description text-justify"
            >Sistemas flexibles, confiables, económicos y totalmente escalables que pueden crecer a medida que cambian los edificios y evolucionan sus necesidades de protección a la vida, notificación que le proporcionan a usted y al personal de respuesta a emergencias información rápida y precisa en caso de emergencia así como avisos direccionables que generan menos interrupciones y permiten mayor continuidad de operaciones.</p>
          </template>
          <template slot="right-text">
            <img src="svg/fire.svg" class="img-fluid py-3" alt="access-control" />
          </template>
        </two-columns>

        <two-columns position-text="left" centered>
          <template slot="title">
            <h3>Automatización industrial y residencial.</h3>
          </template>
          <template>
            <p
              class="description text-justify"
            >Automatización todos los sistemas de la casa y tener un control centralizado por medio de una pantalla táctil, del PDA, del celular, de un control remoto o por Internet, de tal forma que usted no se debe preocupar más de encender o apagar las luces de su casa, o de regar el jardín, ya que el sistema hará eso y mucho más para su comodidad.</p>
            <div
              class="info info-horizontal mw-100 py-2 d-flex justify-content-start align-items-center"
            >
              <div class="icon text-primary m-0 mx-2">
                <i class="fas fa-microphone-alt"></i>
              </div>
              <div class="description text-left">
                <p
                  class="m-0"
                >Integración a sistemas de automatización de alto renombre, control por medio de voz.</p>
              </div>
            </div>
            <div
              class="info info-horizontal mw-100 py-2 d-flex justify-content-start align-items-center"
            >
              <div class="icon text-primary m-0">
                <i class="fas fa-video"></i>
              </div>
              <div class="description text-left">
                <p class="m-0">Control de sistemas residenciales de video y audio.</p>
              </div>
            </div>
            <div
              class="info info-horizontal mw-100 py-2 d-flex justify-content-start align-items-center"
            >
              <div class="icon text-primary m-0 mx-2">
                <i class="far fa-lightbulb"></i>
              </div>
              <div class="description text-left">
                <p class="m-0">Control de sistemas Fotovoltaicos.</p>
              </div>
            </div>
          </template>
          <template slot="right-text">
            <img src="svg/home.svg" class="img-fluid py-3" alt="access-control" />
          </template>
        </two-columns>

        <div class="section-story-overview pt-0">
          <div class="row">
            <div class="col-md-9 mx-auto">
              <h4
                class="description text-center"
              >Instalaciones Eléctricas, planos, cálculos eléctricos, distribución de sistemas especiales así como la supervisión y programación del mismo.</h4>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { GridItem } from "@/components";
export default {
  name: "infrastructure-services",
  bodyClass: "services-page",
  components: {
    GridItem
  },
  data() {
    return {
      social: {
        title: 'Servicios del Departamento de Infraestructura | Proyectos SEES',
        description: 'En Proyectos SEES brindamos solucionesintegrales en tecnología, eficiencia energética, seguridad electrónica y mantenimiento IT.',
        image: 'https://proyectosees.com/img/ees-icon.png'
      }
    };
  },
  head: {
    title: {
      inner: 'Servicios del Departamento de Infraestructura'
    },
    // Meta tags
    meta() {
      return [
        { n: 'description', c: this.social.description, id: 'desc' },
        // Twitter
        { n: 'twitter:card', c: 'summary', id: 'twtca' },
        // { n: 'twitter:site', c: '@username', id: 'twtsi' },
        { n: 'twitter:title', c: this.social.title, id: 'twtti' },
        { n: 'twitter:description', c: this.social.description, id: 'twtde'},
        // { n: 'twitter:creator', c: '@username', id: 'twtcr' },
        { n: 'twitter:image', c: this.social.image, id: 'twtim' },
        // Google+ / Schema.org
        { itemprop: 'name', c: this.social.title, id: 'gglna' },
        { itemprop: 'description', c: this.social.description, id: 'gglde' },
        { itemprop: 'image', c: this.social.image, id: 'gglim' },
        // Facebook / Open Graph
        { p: 'og:title', c: this.social.title, id: 'ogtit' },
        { p: 'og:type', c: 'website', id: 'ogtyp' },
        { p: 'og:url', c: 'https://proyectosees.com/infrastructure-services/', id: 'ogurl' },
        { p: 'og:image', c: this.social.image, id: 'ogima' },
        { p: 'og:description', c: this.social.description, id: 'ogdes' },
        { p: 'og:site_name', c: 'Proyecto SEES', id: 'ogsit' },
        // { p: 'fb:app_id', c: '123456789' },
      ]
    },
    // link tags
    link: [
      { rel: 'canonical', href: 'https://proyectosees.com/infrastructure-services/', id: 'canonical' },
      { rel: 'alternate', href: 'https://proyectosees.com/infrastructure-services/', hreflang: "es-419", id: 'alter' },
    ],
  },
  methods: {
    goto: url => {
      window.open(url, '_blank');
    }
  }
};
</script>
<style>
</style>
